module.exports = {"name":"fxhb-group","version":"1.0.0","basepath":"/","keywords":[],"main":"index.js","dependencies":{"@material-ui/core":"^1.4.3","react-router-dom":"4.1.1","react-dom":"^16.4.2","react":"^16.4.2"}}


//////////////////
// WEBPACK FOOTER
// ./src/package.json
// module id = 524
// module chunks = 0